/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('anchor_button') || el.closest('.anchor_button')) {
      if(!el.classList.contains('anchor_button')) {
      	el = el.closest('.anchor_button');
      }
      e.preventDefault();
      e.stopPropagation();

      let ProductFormEl = el.closest('.ProductForm');
      if(ProductFormEl) {
        let ProductForm__VariantsEl = ProductFormEl.querySelector('.ProductForm__Variants');
        if(ProductForm__VariantsEl) {
          let offsetTop = ProductForm__VariantsEl.offsetTop;
           scroll({
            top: offsetTop,
            behavior: "smooth"
  });
        }
      }
    }
  });

/**
 * Abra
 *
 * Integration with Gift With Purchase offer and your
 * cart drawer.
 *
 * support@abrapromotions.com
 * https://apps.shopify.com/abra-discount-links
 */
window.addEventListener('abra:cart:changed', () => {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
});
